/**
 * Flow Builder / grid cells sometimes return pseudo-XML, e.g. `<NAME>Environment</NAME>`, `<Icon>account</Icon>`.
 * Strip one matching wrapper so matching logic and icon keys see plain text.
 */
export function unwrapXmlStyleContent(raw) {
    let s = raw.trim();
    if (!s)
        return '';
    for (let i = 0; i < 3; i += 1) {
        const m = s.match(/^<([A-Za-z][\w:-]*)[^>]*>([\s\S]*?)<\/\1\s*>$/);
        if (!m)
            break;
        s = m[2].trim();
    }
    return s;
}
